import { render, staticRenderFns } from "./TestTypes.vue?vue&type=template&id=3468ccce&"
import script from "./TestTypes.vue?vue&type=script&lang=js&"
export * from "./TestTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports